@for (demandeContact of demandesContactList; track $index) {
  <app-demande-contact-row
    [demandeContact]="demandeContact"
    [afficherPatient]="afficherPatient"
    ]
  />
} @empty {
  @if (enCoursDeChargement) {
    <p>...</p>
  } @else {
    <p>Aucune demande de contact.</p>
  }
}
